import { Component } from 'react';
import { connect } from 'react-redux';

import { PaymentMethodAuthenticationModal } from '../paymentMethodAuthenticationModal/PaymentMethodAuthenticationModal';
import styles from './ProcessingPaymentModal.module.css';
import Success from './Success/Success';
import Failed from './Failed/Failed';
import Loading from './Loading/Loading';
import BankLogo from './images/bank.svg';
import IwocaLogo from './images/red-iwoca-logo.svg';
import TruelayerLogo from './images/truelayer.svg';
import { RootState } from '@iwProvider/configureStore';
import { DRAW_DOWN_MODE } from '../../funding/ConfirmFundingView/ConfirmFunding.sagas';
import { TRUELAYER_REPAYMENT_TYPE } from '../../earlyRepayment/EarlyRepaymentHelper';

const mapStateToProps = ({
    processingPaymentModal
}: {
    processingPaymentModal: RootState['processingPaymentModal'];
}) => ({
    ...processingPaymentModal
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

function getSenderAndReceiverLogo(
    mode: string | undefined,
    paymentMethod: string | null
) {
    if (mode === DRAW_DOWN_MODE) {
        return [IwocaLogo, BankLogo];
    }
    if (paymentMethod === TRUELAYER_REPAYMENT_TYPE) {
        return [IwocaLogo, TruelayerLogo];
    }
    return [BankLogo, IwocaLogo];
}

class ProcessingPaymentModal extends Component<PropsFromRedux> {
    renderContent() {
        const { paymentStatus, authenticationIframeURL, mode, paymentMethod } =
            this.props;

        const [senderLogo, receiverLogo] = getSenderAndReceiverLogo(
            mode,
            paymentMethod
        );

        switch (paymentStatus) {
            case 'success':
                return (
                    <Success
                        senderLogo={senderLogo}
                        receiverLogo={receiverLogo}
                    />
                );
            case 'authentication_required':
                return (
                    <PaymentMethodAuthenticationModal
                        authenticationIframeURL={authenticationIframeURL!}
                    />
                );
            case 'failure':
                return (
                    <Failed
                        senderLogo={senderLogo}
                        receiverLogo={receiverLogo}
                    />
                );
            default:
                return (
                    <Loading
                        senderLogo={senderLogo}
                        receiverLogo={receiverLogo}
                    />
                );
        }
    }

    render() {
        return (
            <div className={styles.ProcessingPaymentModal}>
                <div className={styles.content}>{this.renderContent()}</div>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(ProcessingPaymentModal);
